import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AboutComponent } from './component/about.component';
import { SectionValuesModule } from '../section-values/section-values.module';
import { AboutRoutingModule } from './about-routing.module';
import { PageHeaderModule } from '../page-header/page-header.module';



@NgModule({
  declarations: [
    AboutComponent
  ],
  imports: [
    CommonModule,
    AboutRoutingModule,
    SectionValuesModule,
    PageHeaderModule
  ]
})
export class AboutModule { }
